import type { IFundTag } from "@interfaces/tag.interface";
import { cn } from "@utils/tailwind.util";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IFundTag;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionFund = ({ item, ...rest }: Props) => {
  const isClosed = item.status === "Closed";

  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-2 p-2">
      <span
        className={cn(
          "h-1.5 w-1.5 flex-shrink-0 rounded-full",
          isClosed ? "border-[1.6px] border-content-secondary" : "bg-emerald-700"
        )}
      />
      <TagLabel className="min-w-0 w-fit">{item.title}</TagLabel>
      {item.vintage_year && (
        <span className="max-w-20 shrink-0 truncate text-xs text-content-secondary">{item.vintage_year}</span>
      )}
    </div>
  );
};
